import React from "react";
import { cn } from "@/lib/utils";

// Single source of truth for the filter bar's sticky surface: opaque bg (must stay
// solid, not translucent, so scrolled table rows never show through) plus a hairline
// border to give it a deliberate edge instead of a flat/flicker-prone merge with content.
export const FILTER_BAR_SURFACE_CLASS = "bg-[#FCFCFD] dark:bg-[#3C5C73]";
export const FILTER_BAR_STICKY_CLASS = cn(
  "sticky top-0 z-40 py-1 border-gray-200 dark:border-white/10",
  FILTER_BAR_SURFACE_CLASS
);

interface StickyFilterBarProps {
  children: React.ReactNode;
  className?: string;
}

const StickyFilterBar: React.FC<StickyFilterBarProps> = ({ children, className }) => {
  return <div className={cn(FILTER_BAR_STICKY_CLASS, className)}>{children}</div>;
};

export default StickyFilterBar;
